module.exports = __webpack_public_path__ + "fonts/sc-regular.473303fb.otf";